export enum PostType {
    Message = 1,
    MessageWithPhoto = 3,
    MessageWithAudioLink = 4,
    MessageWithVideoLink = 5,
}